import { render, staticRenderFns } from "./ComptaWidget.vue?vue&type=template&id=ebe79ae6"
import script from "./ComptaWidget.vue?vue&type=script&lang=js"
export * from "./ComptaWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports